import { useState, useEffect } from 'react';

export function useGHLAuth() {
  const [locationId, setLocationId] = useState<string | null>(null);
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const storedLocationId = localStorage.getItem('ghl_location_id');
      const storedAccessToken = localStorage.getItem('ghl_access_token');

      if (storedLocationId && storedAccessToken) {
        setLocationId(storedLocationId);
        setAccessToken(storedAccessToken);
        setIsAuthenticated(true);
        return;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');

      if (code) {
        exchangeCodeForToken(code);
      } else {
        listenForGHLCredentials();
      }
    };

    checkAuth();
  }, []);

  const exchangeCodeForToken = async (code: string) => {
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/oauth/token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code }),
      });

      const data = await response.json() as {
        success: boolean;
        accessToken?: string;
        refreshToken?: string;
        locationId?: string;
      };

      if (data.accessToken && data.locationId) {
        localStorage.setItem('ghl_access_token', data.accessToken);
        if (data.refreshToken) {
          localStorage.setItem('ghl_refresh_token', data.refreshToken);
        }
        localStorage.setItem('ghl_location_id', data.locationId);

        setAccessToken(data.accessToken);
        setLocationId(data.locationId);
        setIsAuthenticated(true);

        window.history.replaceState({}, document.title, window.location.pathname);
      }
    } catch (error) {
      console.error('OAuth token exchange failed:', error);
    }
  };

  const listenForGHLCredentials = () => {
    window.addEventListener('message', (event) => {
      if (event.data.type === 'ghl-credentials') {
        const { locationId: loc, accessToken: token } = event.data;
        
        if (loc && token) {
          localStorage.setItem('ghl_location_id', loc);
          localStorage.setItem('ghl_access_token', token);
          
          setLocationId(loc);
          setAccessToken(token);
          setIsAuthenticated(true);
        }
      }
    });

    if (window.parent !== window) {
      window.parent.postMessage({ type: 'request-ghl-credentials' }, '*');
    }
  };

  return {
    locationId,
    accessToken,
    isAuthenticated,
  };
}
